import KunLoading22 from './src/index'

KunLoading22.install = function (Vue) {
	Vue.component(KunLoading22.name, KunLoading22);
}

export default KunLoading22;
